export default [
  {label: 'Details', type: 'accordion', width: '100'},
  {label: 'Invite Name', type: 'default', width: ''},
  {label: 'Date Invited', type: 'default', width: ''},
  {label: 'Invited Players', type: 'default', width: ''},
  {label: 'Profiles Name', type: 'default', width: ''},
]
